import { render, staticRenderFns } from "./defined-color-picker.vue?vue&type=template&id=2a41a208&"
import script from "./defined-color-picker.vue?vue&type=script&lang=js&"
export * from "./defined-color-picker.vue?vue&type=script&lang=js&"
import style0 from "./defined-color-picker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports